"use client";

import { AnimatePresence } from "framer-motion";
import { useSearchParams, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { OnboardingScreen } from "./[locale]/components/onboarding-screen";
import { WelcomeScreen } from "./[locale]/components/welcome-screen";
import { InterviewParams } from "./utils";
import { Card } from "./ui/card";
import { useInterviewStore } from "./hooks/use-interview-store";

export function OnboardingContent(props: { data: InterviewParams }) {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [step, setStep] = useState<"welcome" | "onboarding">("welcome");
  const { context } = useInterviewStore();

  useEffect(() => {
    const stepParam = searchParams.get("step");
    if (stepParam === "onboarding") {
      setStep("onboarding");
    } else {
      setStep("welcome");
    }
  }, [searchParams]);

  const handleNext = () => {
    setStep("onboarding");
    const newParams = new URLSearchParams(searchParams);
    newParams.set("step", "onboarding");
    router.push(`?${newParams.toString()}`);
  };

  console.log({ context });

  return (
    <Card>
      <AnimatePresence>
        {step === "welcome" && (
          <WelcomeScreen data={props.data} onNext={handleNext} />
        )}
        {step === "onboarding" && <OnboardingScreen data={props.data} />}
      </AnimatePresence>
    </Card>
  );
}
